/* eslint sort-keys-fix/sort-keys-fix: "error" */
export enum AmplitudeEvent {
  ACCEPT_CGU_CLICKED = 'accept_cgu_clicked',
  ACCOUNT_CREATED_START_CLICKED = 'account_created_start_clicked',
  CHECK_EDUCONNECT_DATA_CLICKED = 'check_Educonnect_data_clicked',
  CHOOSE_METHOD_EDUCONNECT = 'choose_method_educonnect',
  CHOOSE_METHOD_UBBLE = 'choose_method_ubble',
  COME_BACK_LATER_CLICKED = 'come_back_later_clicked',
  CONNECT_WITH_EDUCONNECT_CLICKED = 'connect_with_Educonnect_clicked',
  CONTINUE_SET_BIRTHDAY = 'continue_set_birthday',
  CONTINUE_SET_EMAIL = 'continue_set_email',
  CONTINUE_SET_PASSWORD = 'continue_set_password',
  CREATE_ACCOUNT_CLICKED = 'create_account_clicked',
  EDUCONNECT_EXPLANATION_CLICKED = 'educonnect_explanation_clicked',
  EMAIL_CONFIRMATION_CONSULT_EMAIL_CLICKED = 'email_confirmation_consult_email_clicked',
  EMAIL_CONFIRMATION_HELPCENTER_CLICKED = 'email_confirmation_helpcenter_clicked',
  EMAIL_VALIDATED = 'email_validated',
  GO_TO_UBBLE = 'go_to_ubble',
  ONBOARDING_AGE_INFORMATION_CLICKED = 'onboarding_age_information_clicked',
  ONBOARDING_AGE_SELECTION_CLICKED = 'onboarding_age_selection_clicked',
  ONBOARDING_AGE_SELECTION_PARENT_CLICKED = 'onboarding_age_selection_parent_clicked',
  ONBOARDING_GEOLOCATION_CLICKED = 'onboarding_geolocation_clicked',
  ONBOARDING_STARTED = 'onboarding_started',
  PHONE_NUMBER_CLICKED = 'phone_number_clicked',
  PHONE_VALIDATION_CODE_CLICKED = 'phone_validation_code_clicked',
  QUIT_SIGNUP = 'quit_signup',
  SCREEN_VIEW_COME_BACK_LATER = 'screen_view_come_back_later',
  SCREEN_VIEW_DMS_INTRODUCTION = 'screen_view_dms_introduction',
  SCREEN_VIEW_EXPIRED_OR_LOST_ID = 'screen_view_expired_or_lost_id',
  SCREEN_VIEW_IDENTITY_FORK = 'screen_view_identity_fork',
  SCREEN_VIEW_IDENTITY_CHECK_END = 'screen_view_identity_check_end',
  SCREEN_VIEW_IDENTITY_CHECK_HONOR = 'screen_view_identity_check_honor',
  SCREEN_VIEW_SELECT_ID_ORIGIN = 'screen_view_select_id_origin',
  SCREEN_VIEW_SELECT_ID_STATUS = 'screen_view_select_id_status',
  SCREEN_VIEW_SET_ADDRESS = 'screen_view_set_address',
  SCREEN_VIEW_SET_CITY = 'screen_view_set_city',
  SCREEN_VIEW_SET_EMAIL = 'screen_view_set_email',
  SCREEN_VIEW_SET_NAME = 'screen_view_set_name',
  SCREEN_VIEW_SET_PHONE_NUMBER = 'screen_view_set_phone_number',
  SCREEN_VIEW_SET_PHONE_VALIDATION_CODE = 'screen_view_set_phone_validation_code',
  SCREEN_VIEW_SET_STATUS = 'screen_view_set_status',
  SELECT_ID_STATUS_CLICKED = 'select_id_status_clicked',
  SET_ADDRESS_CLICKED = 'set_address_clicked',
  SET_ID_ORIGIN_CLICKED = 'set_id_origin_clicked',
  SET_NAME_CLICKED = 'set_name_clicked',
  SET_POSTAL_CODE_CLICKED = 'set_postal_code_clicked',
  SET_STATUS_CLICKED = 'set_status_clicked',
  SHOW_PARENT_INFORMATION_MODAL = 'show_parent_information_modal',
  STEPPER_CLICKED = 'stepper_clicked',
}
